import { useCallback, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';

import { synchronizationDialogSelector } from './synchronization-dialog.selectors';
import { close, open } from './synchronization-dialog.slice';

function useSynchronizationDialog() {
  const dispatch = useAppDispatch();
  const { isOpen: isDialogOpen } = useAppSelector(synchronizationDialogSelector);

  const openDialog = useCallback(() => {
    dispatch(open());
  }, [dispatch]);

  const closeDialog = useCallback(() => {
    dispatch(close());
  }, [dispatch]);

  return useMemo(
    () => ({
      isDialogOpen,
      openDialog,
      closeDialog,
    }),
    [isDialogOpen, openDialog, closeDialog],
  );
}

export default useSynchronizationDialog;
